import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './common/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialModule } from './material/material.module';
import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { AuthInterceptorService } from './interceptor/auth-interceptor.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { SideNavComponent } from './common/side-nav/side-nav.component';

import { HighchartsChartModule } from 'highcharts-angular';
import { AccountingModule } from './components/accounting/accounting.module';
import { InvoiceDetailsComponent } from './components/accounting/invoice/invoice-details/invoice-details.component';
import { MatTableModule } from '@angular/material/table';
import { LoaderComponent } from './common/loader/loader.component';
import { LoaderService } from './helpers/loader.service';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { SearchComponent } from './common/search/search.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';
import { SearchGridComponent } from './common/search-grid/search-grid.component';
import { FilterGridComponent } from './common/search/filter-grid/filter-grid.component';
import { NavigationService } from './navigation.service';
import { MessageService } from './message.service';
import { BookingComponent } from './components/booking/booking.component';

@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent,
    LoginComponent,
    InvoiceDetailsComponent,
    LoaderComponent,
    SearchComponent,
    HighlightPipe,
    SentenceCasePipe,
    SearchGridComponent,
    FilterGridComponent,
    BookingComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    DashboardModule,
    AccountingModule,
    ReactiveFormsModule,
    MaterialModule,
    MatTableModule,
    MatPaginatorModule,
    HighchartsChartModule,
    HttpClientModule,
    FormsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    LoaderService, // Provide the LoaderService
    {
      provide: HTTP_INTERCEPTORS, // Angular's token for interceptors
      useClass: LoaderInterceptor, // Your custom interceptor class
      multi: true, // Essential: Allows multiple interceptors to be registered
    },
    NavigationService,
    MessageService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
